<template>
    <div @click="scroll" class="scroll-indicator">
        <div class="elements">
            <img src="/assets/img/drape-top.png">
            <img src="/assets/img/drape-center.png">
            <img src="/assets/img/drape-bottom.png">
        </div>
    </div>
</template>
<script>
    import {TweenLite} from 'gsap'
    import ScrollToPlugin from 'gsap/ScrollToPlugin'

    export default {
        methods: {
            scroll() {
                TweenLite.to( window, 1, { scrollTo: { y: window.innerHeight, offsetY: 90 } } )
            }
        }
    }
</script>